import { AssetModel } from '@customer/store/apis/assetsApi';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface GeofenceData {
  where: string;
  version: number;
  ts?: string;
  error: boolean;
}

interface UseAssetGeofenceTableDataProps {
  asset?: AssetModel;
}

export const useAssetGeofenceTableData = ({ asset }: UseAssetGeofenceTableDataProps) => {
  const { t } = useTranslation();

  return useMemo<GeofenceData[]>(() => {
    if (!asset) {
      return [];
    }

    return [
      {
        where: t('GeofenceAssetVersion'),
        version: asset.geoVer,
        ts: asset.geoTs,
        error: asset.geoVer !== asset.siteGeoVer,
      },
      {
        where: t('GeofenceSiteVersion'),
        version: asset.siteGeoVer,
        ts: asset.siteGeoTs,
        error: false,
      },
    ];
  }, [asset, t]);
};
